import { graphql, useStaticQuery } from "gatsby";
import { useMemo } from "react";

const DEFAULT_LANG = process.env.GATSBY_DEFAULT_LANG || "en";

/**
 * Resolves the Organization config story for JSON-LD.
 *
 * This space is folder-based (`en/…`) rather than Storyblok field i18n, so each
 * locale has its own `{lang}/config/organization` story. Matching uses
 * `full_slug`, falling back to English then any remaining entry.
 */
export function useOrganizationConfig(language = DEFAULT_LANG) {
   const data = useStaticQuery(graphql`
      query OrganizationConfigQuery {
         organizations: allStoryblokEntry(
            filter: { field_component: { eq: "config_organization" } }
         ) {
            edges {
               node {
                  full_slug
                  content
               }
            }
         }
      }
   `);

   return useMemo(() => {
      const entries = (data?.organizations?.edges || []).map(({ node }) => ({
         full_slug: node.full_slug,
         content: JSON.parse(node.content),
      }));

      const match =
         entries.find(({ full_slug }) => full_slug.startsWith(`${language}/`)) ||
         entries.find(({ full_slug }) => full_slug.endsWith("en/config/organization")) ||
         entries.find(
            ({ full_slug }) =>
               full_slug === "config/organization" || full_slug.endsWith("/config/organization"),
         ) ||
         entries[0];

      return match?.content;
   }, [data, language]);
}
